import { render, staticRenderFns } from "./VideoAnalitycsPromo.vue?vue&type=template&id=2f912f6a&scoped=true"
import script from "./VideoAnalitycsPromo.vue?vue&type=script&lang=js"
export * from "./VideoAnalitycsPromo.vue?vue&type=script&lang=js"
import style0 from "./VideoAnalitycsPromo.vue?vue&type=style&index=0&id=2f912f6a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f912f6a",
  null
  
)

export default component.exports